module.exports = __webpack_public_path__ + "static/media/property-managers-7.52fe37ad.svg";